module.exports = __webpack_public_path__ + "static/media/logoLargeWhite.440731c7.svg";